import { useEffect } from 'react';
import main from '../../project/uikit/color-variables/main.module.scss';
import admin from '../../project/uikit/color-variables/admin.module.scss';
import office from '../../project/uikit/color-variables/office.module.scss';
import { getDimensions } from '../../hybrid/wrappers';

const useTheme = (protect) => {
    const setVh = () => {
        const { height } = getDimensions();
        document.documentElement.style.setProperty('--vh', `${height * 0.01}px`);
    };

    useEffect(() => {
        const theme = protect === 'office' ? office : protect === 'admin' ? admin : main;
        for (const key in theme) {
            document.documentElement.style.setProperty(`--${key}`, theme[key]);
            document.documentElement.dataset.page = protect || 'main';
        }

        setVh();
        window.addEventListener('resize', setVh);

        document.body.classList.remove('is_loading');

        return () => {
            window.removeEventListener('resize', setVh);
        };
        // return () => {
        //     for (const key in main) {
        //         document.documentElement.style.setProperty(`--${key}`, main[key]);
        //         document.documentElement.dataset.page = 'main';
        //     }
        // };
    }, [protect]);
};
export default useTheme;
